module.exports = __webpack_public_path__ + "img/dead-dry-hairy-tree-03.84a0b31c.png";